import { render, staticRenderFns } from "./WorkflowPreview.vue?vue&type=template&id=4f6b4453&scoped=true"
import script from "./WorkflowPreview.vue?vue&type=script&lang=js"
export * from "./WorkflowPreview.vue?vue&type=script&lang=js"
import style0 from "./WorkflowPreview.vue?vue&type=style&index=0&id=4f6b4453&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6b4453",
  null
  
)

export default component.exports